import React from 'react';
import { formInput } from 'src/components/helpers';
import moment from 'src/services/moment_instance';
import EventHeading from 'src/containers/events/EventHeading';
import { Button, Modal, Input } from 'semantic-ui-react';
import Form from 'src/components/form/Form';
import Swal from 'sweetalert2';
import membersForms from 'src/services/api/membersForms';
import {
  verifyReservationForm,
  ReservationExtraInfo,
  sendReservationHelper,
  reservationRequiresCivil,
} from 'src/containers/events/reservation/components/reservationExtraInfo';
import { shouldLockGuestIdentity } from 'src/components/helpers/guests/guestIdentity';

const AddAGuest = (props) => {
  const { event, getEvent } = props;
  const [modalOpen, set_modalOpen] = React.useState(false);
  const [inputs, set_inputs] = React.useState({ es_tarjetahabiente: 'Sí' });
  const [loading, set_loading] = React.useState(false);
  const [errorInputs, set_errorInputs] = React.useState({});

  let age = (birthdate) => moment().diff(birthdate, 'years');

  const handleDropDown = ({ name, value }) => {
    set_inputs({ ...inputs, [name]: value });
  };

  const loadMember = ({ identification, phone } = {}) => {
    if (!identification || !phone) return Swal.fire('Para buscar escribe la cédula y el celular');

    set_loading(true);

    membersForms
      .getAMember({ identification, phone })
      .then((response) => {
        if (response.data.success) {
          set_loading(false);
          if (response.data.finded && response.data.match) {
            set_inputs((prev) => ({
              ...prev,
              ...response.data.guest,
              identification,
              phone,
            }));
          } else {
            if (response.data.message) Swal.fire(response.data.message);
          }
        }
      })
      .catch((error) => {
        set_loading(false);
        if (error.response) Swal.fire(error.response.data.message);
      });
  };

  const getAMember = (e) => {
    e.preventDefault();
    loadMember({ identification: inputs.identification, phone: inputs.phone });
  };

  const sendInfo = () => {
    if (verifyReservationForm(event, () => event.eventSlugname, inputs, set_errorInputs)) {
      return;
    }
    set_loading(true);
    sendReservationHelper({
      inputs,
      event,
      eventSlugname: event.eventSlugname,
      special: true,
      eventSelected: event,
    })
      .then((response) => {
        set_loading(false);
        if (response.data.success) {
          set_modalOpen(false);
          getEvent(event.id, event.eventSlugname);
          set_inputs({});
        }
        if (response.data.message) Swal.fire(response.data.message);
      })
      .catch((error) => {
        if (error.response) Swal.fire(error.response.data.message);
        set_modalOpen(false);
        set_loading(false);
      });
  };

  const handleInputs = (event) => {
    let value = event.target.value;
    let name = event.target.name;
    set_inputs({ ...inputs, [name]: value });
  };

  const selectHandle = (a, { value, name }) => handleInputs({ target: { value, name } });

  return (
    <>
      <Button onClick={() => set_modalOpen(true)}>Agregar asistente</Button>
      <Modal open={modalOpen} onClose={() => set_modalOpen(false)}>
        <Modal.Header>Agregar asistente de manera manual</Modal.Header>

        <Modal.Content>
          <EventHeading name={event?.eventSlugname} date={event?.date} align="left" />
          {Object.values(errorInputs)?.includes(true) && !shouldLockGuestIdentity(inputs) && (
            <h4 style={{ color: 'red' }}>Por favor verifica los campos en rojo.</h4>
          )}
          <div>
            <Button loading={loading} disabled={loading} onClick={(e) => getAMember(e)}>
              Llenar información
            </Button>
            <p style={{ fontSize: '12px', margin: 0 }}>
              Ingresa el celular y cédula para traer la información que hay en el sistema asociados.
            </p>
          </div>
          {!!(age(inputs.birthdate) <= 14 && inputs.birthdate) && (
            <div>
              <p style={{ margin: '0' }}>Información para menores de 14 años</p>
              {formInput({
                Input,
                handler: handleInputs,
                label: 'Nombre del acudiente',
                name: 'parentFullname',
                value: inputs.parentFullname || '',
                errorInputs,
              })}
              {formInput({
                Input,
                handler: handleInputs,
                label: 'Cédula del acudiente',
                name: 'parentIdentification',
                value: inputs.parentIdentification || '',
                errorInputs,
                type: 'number',
              })}
            </div>
          )}
          <Form
            Attendant={inputs}
            userprofile={true}
            handleInputs={handleInputs}
            handleDropDown={handleDropDown}
            errorInputs={errorInputs}
            showOcupation
            showAge
            showGender
            showCivil={reservationRequiresCivil(event?.eventSlugname)}
            moreInfo={() => (
              <ReservationExtraInfo
                inputs={inputs}
                handleInputs={handleInputs}
                selectHandle={selectHandle}
                errorInputs={errorInputs}
                defaulteventSlugname={() => event.eventSlugname}
                event={event}
              />
            )}
            showBirthdate
            loadedData={loading}
            setAttendant={set_inputs}
            setErrorInputs={set_errorInputs}
            onGuestUpdated={loadMember}
          />
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={() => set_modalOpen(false)}>Cerrar</Button>
          <Button primary onClick={sendInfo} disabled={loading}>
            Agregar
          </Button>
        </Modal.Actions>
      </Modal>
    </>
  );
};

export default AddAGuest;
